// Shared helpers for the stock QR feature.
// The QR only carries *identifiers* (not stock numbers or names) so:
//  - printed labels never go stale (the scan popup always loads live data), and
//  - the code stays sparse, which keeps small 4-5 cm stickers easy to scan.

export const SCAN_PATH = "/stock-scan";

/**
 * target = { type: "product" | "raw-material", materialId, combinationIds: number[] }
 * Result looks like:  https://host/stock-scan?t=p&m=12&c=34   (several variants: c=34,35,36)
 */
export const buildScanUrl = (target, origin) => {
  const base =
    origin || (typeof window !== "undefined" ? window.location.origin : "");
  const t = target.type === "raw-material" ? "r" : "p";
  return `${base}${SCAN_PATH}?t=${t}&m=${target.materialId}&c=${target.combinationIds.join(",")}`;
};

// Also understands the older long format (type / mid / cids / tpl) so QR codes printed earlier keep working.
export const parseScanParams = (search) => {
  const p = new URLSearchParams(search);
  const rawType = p.get("t") || p.get("type") || "";
  const cids = (p.get("c") || p.get("cids") || "")
    .split(",")
    .map((x) => parseInt(x, 10))
    .filter((x) => !Number.isNaN(x));
  return {
    type:
      rawType === "r" || rawType === "raw-material"
        ? "raw-material"
        : "product",
    materialId: parseInt(p.get("m") || p.get("mid"), 10) || 0,
    materialName: p.get("mn") || "",
    combinationName: p.get("cn") || "",
    combinationIds: cids,
  };
};

// API paths (relative to the inv-manager base URL)
export const getStockEndpoint = (type, combinationId) =>
  type === "raw-material"
    ? `/warehouse-stock/raw-material-combination/${combinationId}`
    : `/warehouse-stock/product-combination/${combinationId}`;

export const getTransactionEndpoint = (type) =>
  type === "raw-material"
    ? "/warehouse-stock/bulk/transaction-type/raw-material"
    : "/warehouse-stock/bulk/transaction-type/product";

// Display names for the three transaction types (used everywhere in the admin UI)
export const TRANSACTION_LABELS = {
  INBOUND: "Inbound / Add Stock",
  OUTBOUND: "Outbound / Remove Stock",
  TRANSFER: "Transfer / Rerack Stock",
};
